import type { TagDefinitionKey } from "../types";

interface TagFieldProps {
  tagKey: TagDefinitionKey;
  selectedValues: string[];
  onChange: (values: string[]) => void;
  id?: string;
  className?: string;
  disabled?: boolean;
}

export default function TagField({
  tagKey,
  selectedValues,
  onChange,
  id,
  className = "input",
  disabled,
}: TagFieldProps) {
  if (!tagKey.multiValue) {
    const currentValue = selectedValues[0] ?? "";
    return (
      <select
        id={id}
        value={currentValue}
        disabled={disabled}
        onChange={(e) => {
          const v = e.target.value;
          onChange(v ? [v] : []);
        }}
        className={className}
      >
        <option value="">Select {tagKey.label.toLowerCase()}</option>
        {tagKey.values.map((tv) => (
          <option key={tv.value} value={tv.value}>
            {tv.label}
          </option>
        ))}
      </select>
    );
  }

  // Multi-value variants (checkbox group, searchable multi-select) will be
  // added when a multi-value tag key is reintroduced into the UI.
  return null;
}
